interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <nav className="flex items-center justify-center gap-2 mt-10" aria-label="分页">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="w-10 h-10 flex items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`w-10 h-10 flex items-center justify-center rounded-md text-sm font-label transition-colors cursor-pointer ${
            p === page
              ? "bg-primary-500 text-background-50 font-medium"
              : "border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
          }`}
          aria-current={p === page ? "page" : undefined}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="w-10 h-10 flex items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}